/* eslint-disable prefer-destructuring */
import { useEffect } from 'react';
import { DOM, isBrowser } from '@app/utils';

const hasRiskified = () => {
  if (isBrowser) {
    return window.RISKX;
  }

  return null;
};

const useRiskified = () => {
  useEffect(() => {
    if (!hasRiskified() && isBrowser) {
      (function () {
        function riskifiedBeaconLoad() {
          const store_domain = 'stockx.com';
          const session_id = DOM.getCookie('stockx_session'); // Set to a unique session ID for the visitor's current browsing session.
          const url = `${
            document.location.protocol === 'https:' ? 'https://' : 'http://'
          }beacon.riskified.com?shop=${store_domain}&sid=${session_id}`;

          const s = document.createElement('script');
          s.type = 'text/javascript';
          s.async = true;
          s.src = url;
          const x = document.getElementsByTagName('script')[0];
          x.parentNode?.insertBefore(s, x);
        }

        if (window.attachEvent) {
          window.attachEvent('onload', riskifiedBeaconLoad);
        } else {
          window.addEventListener('load', riskifiedBeaconLoad, false);
        }
      })();
    }
  }, []);
};

export default useRiskified;
